import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.primaryLight,
    paragraph: p => p.accentWhite,
    navbarBg: p => p.tertiaryDark,
    background: p => p.tertiaryDark,
    newsBackground: p => p.primaryLight,
    socialColor: p => p.accentWhite,
    sliderActionsBackground: p => `rgba(${hexToRgb(p.primaryLight)}, 0.3)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryLight,
    background: p => p.tertiaryLight,
    newsBackground: p => p.primaryDark,
    socialColor: p => p.tertiaryDark,
    sliderActionsBackground: p => `rgba(${hexToRgb(p.primaryDark)}, 0.3)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryExtraLight,
    background: p => p.tertiaryExtraLight,
    newsBackground: p => p.primaryDark,
    socialColor: p => p.tertiaryDark,
    sliderActionsBackground: p => `rgba(${hexToRgb(p.primaryDark)}, 0.3)`
  }
}
